import { render } from "./AlertMessage.vue?vue&type=template&id=4d315bfe&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=4d315bfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d315bfe"]])

export default __exports__